import { render, staticRenderFns } from "./PassRecovery.vue?vue&type=template&id=4410a8ae&"
import script from "./PassRecovery.vue?vue&type=script&lang=js&"
export * from "./PassRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports